export default "__VITE_ASSET__BPidtXp3__"